import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { getDashboardForRole, getStoredUser } from "./components/config/authUtils";

// Public Routes
import Login from "./components/auth/Login";
import Lockscreen from "./components/auth/Lockscreen";
import PWAUpdatePrompt, { usePWAUpdate } from "./components/common/PWAUpdatePrompt";

// HR Admin / Manager Routes
import Dashboard from "./components/hr manager/screens/main/Dashboard";
import Departments from "./components/hr manager/screens/main/Departments";
import CreateDepartment from "./components/hr manager/screens/main/CreateDepartment";
import CostCenters from "./components/hr manager/screens/main/CostCenters";
import CreateCostCenter from "./components/hr manager/screens/main/CreateCostCenter";
import CreateEmployee from "./components/hr manager/screens/main/CreateEmployee";
import UpdateEmployee from "./components/hr manager/screens/main/UpdateEmployee";
import Employees from "./components/hr manager/screens/main/Employees";
import HREmployees from "./components/hr manager/screens/main/HREmployees";
import AllEmployeesGoalsReview from "./components/hr manager/screens/main/AllEmployeesGoalsReview";
import HRAddKRA from "./components/hr manager/screens/main/HRAddKRA";
import HRKRAs from "./components/hr manager/screens/main/HRKRAs";
import HRCreateGoal from "./components/hr manager/screens/main/HRCreateGoal";
import HRGoals from "./components/hr manager/screens/main/HRGoals";
import MyGoalReviews from "./components/hr manager/screens/main/MyGoalReview";
import HRImportKPIs from "./components/hr manager/screens/main/HRImportKPIs";
import HRCreateImprovementPlan from "./components/hr manager/screens/main/HRCreateImprovementPlan";
import HRImprovementPlans from "./components/hr manager/screens/main/HRImprovementPlans";
import HREditIP from "./components/hr manager/screens/main/HREditIP";
import HRProfile from "./components/hr manager/screens/main/HRProfile";
import HRChangePassword from "./components/hr manager/screens/main/HRChangePassword";
import HRTwoFactorAuth from "./components/hr manager/screens/main/HRTwoFactorAuth";
import EmployeeGoals from "./components/hr manager/screens/main/EmployeeGoals";
import HREmployeeGoals from "./components/hr manager/screens/main/HREmployeeGoals";
import HREmployeesGoals from "./components/hr manager/screens/main/HREmployeesGoals";
import HREmployeesPendingGoals from "./components/hr manager/screens/main/HREmployeesPendingGoals";
import HREmployeeGoalsReview from "./components/hr manager/screens/main/HREmployeeGoalsReview";
import DepartmentEmployeesImprovementPlans from "./components/hr manager/screens/main/DepartmentEmployeesImprovementPlans";
import Analytics from "./components/hr manager/screens/main/Analytics";
import EmployeeReport from "./components/hr manager/screens/main/EmployeeReport";

// COS Routes
import COSDashboard from "./components/cos/screens/main/COSDashboard";
import COSChangePassword from "./components/cos/screens/main/COSChangePassword";
import COSTwoFactorAuth from "./components/cos/screens/main/COSTwoFactorAuth";
import COSCreateEmployee from "./components/cos/screens/main/COSCreateEmployee";
import COSEditEmployee from "./components/cos/screens/main/COSEditEmployee";
import COSEmployees from "./components/cos/screens/main/COSEmployees";
import COSAddKRA from "./components/cos/screens/main/COSAddKRA";
import COSKRAs from "./components/cos/screens/main/COSKRAs";
import COSCreateGoal from "./components/cos/screens/main/COSCreateGoal";
import COSGoals from "./components/cos/screens/main/COSGoals";
import COSGoalsReview from "./components/cos/screens/main/COSGoalsReview";
import COSPendingGoals from "./components/cos/screens/main/COSPendingGoals";
import COSEmployeeGoals from "./components/cos/screens/main/COSEmployeeGoals";
import COSEmployeeGoalsReview from "./components/cos/screens/main/COSEmployeeGoalsReview";
import COSCreateImprovementPlan from "./components/cos/screens/main/COSCreateImprovementPlan";
import COSImprovementPlans from "./components/cos/screens/main/COSImprovementPlans";
import COSEditIP from "./components/cos/screens/main/COSEditIP";
import HODsImprovementPlans from "./components/cos/screens/main/HODsImprovementPlans";

// COO Routes
import COODashboard from "./components/coo/screens/main/COODashboard";
import COOChangePassword from "./components/coo/screens/main/COOChangePassword";
import COOTwoFactorAuth from "./components/coo/screens/main/COOTwoFactorAuth";
import COOCreateEmployee from "./components/coo/screens/main/COOCreateEmployee";
import COOEditEmployee from "./components/coo/screens/main/COOEditEmployee";
import COOEmployees from "./components/coo/screens/main/COOEmployees";
import COOAddKRA from "./components/coo/screens/main/COOAddKRA";
import COOKRAs from "./components/coo/screens/main/COOKRAs";
import COOCreateGoal from "./components/coo/screens/main/COOCreateGoal";
import COOGoals from "./components/coo/screens/main/COOGoals";
import COOGoalsReview from "./components/coo/screens/main/COOGoalsReview";
import COOPendingGoals from "./components/coo/screens/main/COOPendingGoals";
import COOEmployeeGoals from "./components/coo/screens/main/COOEmployeeGoals";
import COOEmployeeGoalsReview from "./components/coo/screens/main/COOEmployeeGoalsReview";
import COOCreateImprovementPlan from "./components/coo/screens/main/COOCreateImprovementPlan";
import COOImprovementPlans from "./components/coo/screens/main/COOImprovementPlans";
import COOEditIP from "./components/coo/screens/main/COOEditIP";
import COOHODsImprovementPlans from "./components/coo/screens/main/HODsImprovementPlans";
import HODsReport from "./components/coo/screens/main/HODsReport";

// HOD Routes
import HODDashboard from "./components/hod/screens/main/HODDashboard";
import HODChangePassword from "./components/hod/screens/main/HODChangePassword";
import HODTwoFactorAuth from "./components/hod/screens/main/HODTwoFactorAuth";
import HODCreateEmployee from "./components/hod/screens/main/HODCreateEmployee";
import HODUpdateEmployee from "./components/hod/screens/main/HODUpdateEmployee";
import DepartmentEmployees from "./components/hod/screens/main/DepartmentEmployees";
import HODAddKRA from "./components/hod/screens/main/HODAddKRA";
import HODKRAs from "./components/hod/screens/main/HODKRAs";
import HODCreateGoal from "./components/hod/screens/main/HODCreateGoal";
import HODGoals from "./components/hod/screens/main/HODGoals";
import PendingGoals from "./components/hod/screens/main/PendingGoals";
import HODEmployeeGoals from "./components/hod/screens/main/HODEmployeeGoals";
import EmployeeGoalsReviews from "./components/hod/screens/main/EmployeeGoalsReviews";
import HODCreateImprovementPlan from "./components/hod/screens/main/HODCreateImprovementPlan";
import HODImprovementPlan from "./components/hod/screens/main/HODImprovementPlan";
import HODEditIP from "./components/hod/screens/main/HODEditIP";
import MyReviews from "./components/hod/screens/main/MyReviews";
import HODEmployeeReport from "./components/hod/screens/main/HODEmployeeReport";
import EmployeeImprovementPlan from "./components/hod/screens/main/EmployeeImprovementPlan";
import HODProfile from "./components/hod/screens/main/HODProfile";

// Employee Routes
import EmployeeDashboard from "./components/employee/screens/main/EmployeeDashboard";
import ChangePassword from "./components/employee/screens/main/ChangePassword";
import EmployeeTwoFactorAuth from "./components/employee/screens/main/EmployeeTwoFactorAuth";
import CreateGoal from "./components/employee/screens/main/CreateGoal";
import AddKRA from "./components/employee/screens/main/AddKRA";
import CreateImprovementPlan from "./components/employee/screens/main/CreateImprovementPlan";
import EmployeeEditIP from "./components/employee/screens/main/EmployeeEditIP";
import GoalReviews from "./components/employee/screens/main/GoalReviews";
import ImprovementPlans from "./components/employee/screens/main/ImprovementPlans";
import KRAs from "./components/employee/screens/main/KRAs";
import MyGoals from "./components/employee/screens/main/MyGoals";
import SystemUpdates from "./components/hr manager/screens/main/SystemUpdates";

const resolveRoleDashboard = () => {
  const storedUser = getStoredUser();
  const role =
    Cookies.get("role") ||
    storedUser?.role ||
    storedUser?.role_display;
  return getDashboardForRole(role) || "/login";
};

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!Cookies.get("token");
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = !!Cookies.get("token");
  return !isAuthenticated ? (
    children
  ) : (
    <Navigate to={resolveRoleDashboard()} replace />
  );
};

const RoleRedirect = () => {
  const isAuthenticated = !!Cookies.get("token");
  return isAuthenticated ? (
    <Navigate to={resolveRoleDashboard()} replace />
  ) : (
    <Navigate to="/login" replace />
  );
};

function App() {
  const { showPrompt, registration, dismiss } = usePWAUpdate();

  return (
    <div className="App">
      <Router>
        {showPrompt && <PWAUpdatePrompt registration={registration} onDismiss={dismiss} />}
        <Routes>
          {/* Root: redirect to login or role-specific dashboard */}
          <Route path="/" element={<RoleRedirect />} />

          {/* Public Routes */}
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/lockscreen" element={<PublicRoute><Lockscreen /></PublicRoute>} />

          {/* HR Dashboard */}
          <Route path="/hr/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />

          {/* Departments */}
          <Route path="/hr/department/add" element={<ProtectedRoute><CreateDepartment /></ProtectedRoute>} />
          <Route path="/hr/departments/add" element={<ProtectedRoute><CreateDepartment /></ProtectedRoute>} />
          <Route path="/hr/departments" element={<ProtectedRoute><Departments /></ProtectedRoute>} />

          {/* Cost Centers */}
          <Route path="/hr/cost-centers/add" element={<ProtectedRoute><CreateCostCenter /></ProtectedRoute>} />
          <Route path="/hr/cost-centers" element={<ProtectedRoute><CostCenters /></ProtectedRoute>} />

          {/* Employees */}
          <Route path="/hr/employees/add" element={<ProtectedRoute><CreateEmployee /></ProtectedRoute>} />
          <Route path="/hr/employees/update/:id" element={<ProtectedRoute><UpdateEmployee /></ProtectedRoute>} />
          <Route path="/hr/employees" element={<ProtectedRoute><HREmployees /></ProtectedRoute>} />
          <Route path="/hr/all-employees" element={<ProtectedRoute><Employees /></ProtectedRoute>} />
          <Route path="/hr/department-employees" element={<ProtectedRoute><HREmployees /></ProtectedRoute>} />
          <Route path="/hr/employee/:id/update" element={<ProtectedRoute><UpdateEmployee /></ProtectedRoute>} />

          {/* Employee Goal & KPI Management */}
          <Route path="/hr/employee-goals/:id" element={<ProtectedRoute><HREmployeesGoals /></ProtectedRoute>} />
          <Route path="/hr/employee/:id/goals" element={<ProtectedRoute><EmployeeGoals /></ProtectedRoute>} />
          <Route path="/hr/employee-goals/:id/reviews" element={<ProtectedRoute><HREmployeeGoalsReview /></ProtectedRoute>} />
          <Route path="/hr/employee-goals-review/:id" element={<ProtectedRoute><HREmployeeGoalsReview /></ProtectedRoute>} />
          <Route path="/hr/employee/:id/reviews" element={<ProtectedRoute><AllEmployeesGoalsReview /></ProtectedRoute>} />
          <Route path="/hr/employees-pending-goals" element={<ProtectedRoute><HREmployeesPendingGoals /></ProtectedRoute>} />
          <Route path="/hr/department-employees-improvement-plans" element={<ProtectedRoute><DepartmentEmployeesImprovementPlans /></ProtectedRoute>} />
          <Route path="/hr/department-employee/:id/goals" element={<ProtectedRoute><HREmployeeGoals /></ProtectedRoute>} />
          <Route path="/hr/employee/:employeeId/report" element={<ProtectedRoute><EmployeeReport /></ProtectedRoute>} />

          {/* Personal Key Result Areas (KRAs) */}
          <Route path="/hr/key-result-areas/add" element={<ProtectedRoute><HRAddKRA /></ProtectedRoute>} />
          <Route path="/hr/key-result-areas" element={<ProtectedRoute><HRKRAs /></ProtectedRoute>} />

          {/* Personal KPIs */}
          <Route path="/hr/kpis/add" element={<ProtectedRoute><HRCreateGoal /></ProtectedRoute>} />
          <Route path="/hr/kpis" element={<ProtectedRoute><HRGoals /></ProtectedRoute>} />
          <Route path="/hr/kpis/import" element={<ProtectedRoute><HRImportKPIs /></ProtectedRoute>} />
          <Route path="/hr/kpi-reviews" element={<ProtectedRoute><MyGoalReviews /></ProtectedRoute>} />
          <Route path="/hr/my-goal-reviews" element={<ProtectedRoute><MyGoalReviews /></ProtectedRoute>} />

          {/* Personal Improvement Plans */}
          <Route path="/hr/improvement-plans/add" element={<ProtectedRoute><HRCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/hr/create-improvement-plan" element={<ProtectedRoute><HRCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/hr/improvement-plans" element={<ProtectedRoute><HRImprovementPlans /></ProtectedRoute>} />
          <Route path="/hr/edit-improvement-plan/:id" element={<ProtectedRoute><HREditIP /></ProtectedRoute>} />

          {/* Profile & Account (HR) */}
          <Route path="/hr/profile" element={<ProtectedRoute><HRProfile /></ProtectedRoute>} />
          <Route path="/hr/change-password" element={<ProtectedRoute><HRChangePassword /></ProtectedRoute>} />
          <Route path="/hr/two-factor-authentication" element={<ProtectedRoute><HRTwoFactorAuth /></ProtectedRoute>} />

          {/* COS Routes */}
          <Route path="/cos/dashboard" element={<ProtectedRoute><COSDashboard /></ProtectedRoute>} />
          <Route path="/cos/change-password" element={<ProtectedRoute><COSChangePassword /></ProtectedRoute>} />
          <Route path="/cos/two-factor-authentication" element={<ProtectedRoute><COSTwoFactorAuth /></ProtectedRoute>} />

          <Route path="/cos/employees" element={<ProtectedRoute><COSEmployees /></ProtectedRoute>} />
          <Route path="/cos/employees/add" element={<ProtectedRoute><COSCreateEmployee /></ProtectedRoute>} />
          <Route path="/cos/employees/update/:id" element={<ProtectedRoute><COSEditEmployee /></ProtectedRoute>} />
          <Route path="/cos/employee/:id/update" element={<ProtectedRoute><COSEditEmployee /></ProtectedRoute>} />

          <Route path="/cos/key-result-areas" element={<ProtectedRoute><COSKRAs /></ProtectedRoute>} />
          <Route path="/cos/create-key-result-area" element={<ProtectedRoute><COSAddKRA /></ProtectedRoute>} />

          <Route path="/cos/kpis" element={<ProtectedRoute><COSGoals /></ProtectedRoute>} />
          <Route path="/cos/kpis/add" element={<ProtectedRoute><COSCreateGoal /></ProtectedRoute>} />
          <Route path="/cos/create-goal" element={<ProtectedRoute><COSCreateGoal /></ProtectedRoute>} />
          <Route path="/cos/kpi-reviews" element={<ProtectedRoute><COSGoalsReview /></ProtectedRoute>} />
          <Route path="/cos/my-goal-reviews" element={<ProtectedRoute><COSGoalsReview /></ProtectedRoute>} />
          <Route path="/cos/my-goals-reviews" element={<ProtectedRoute><COSGoalsReview /></ProtectedRoute>} />

          <Route path="/cos/pending-goals" element={<ProtectedRoute><COSPendingGoals /></ProtectedRoute>} />
          <Route path="/cos/employee-goals/:id" element={<ProtectedRoute><COSEmployeeGoals /></ProtectedRoute>} />
          <Route path="/cos/employee/:id/goals" element={<ProtectedRoute><COSEmployeeGoals /></ProtectedRoute>} />
          <Route path="/cos/employee-goals/:id/reviews" element={<ProtectedRoute><COSEmployeeGoalsReview /></ProtectedRoute>} />
          <Route path="/cos/employee-goals-review/:id" element={<ProtectedRoute><COSEmployeeGoalsReview /></ProtectedRoute>} />

          <Route path="/cos/improvement-plans" element={<ProtectedRoute><COSImprovementPlans /></ProtectedRoute>} />
          <Route path="/cos/improvement-plans/add" element={<ProtectedRoute><COSCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/cos/create-improvement-plan" element={<ProtectedRoute><COSCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/cos/edit-improvement-plan/:id" element={<ProtectedRoute><COSEditIP /></ProtectedRoute>} />
          <Route path="/cos/hods-improvement-plans" element={<ProtectedRoute><HODsImprovementPlans /></ProtectedRoute>} />
          {/* <Route path="/cos/hod/:employeeId/report" element={<ProtectedRoute><HODsReport /></ProtectedRoute>} /> */}

          {/* COO Routes */}
          <Route path="/coo/dashboard" element={<ProtectedRoute><COODashboard /></ProtectedRoute>} />
          <Route path="/coo/change-password" element={<ProtectedRoute><COOChangePassword /></ProtectedRoute>} />
          <Route path="/coo/two-factor-authentication" element={<ProtectedRoute><COOTwoFactorAuth /></ProtectedRoute>} />

          <Route path="/coo/employees" element={<ProtectedRoute><COOEmployees /></ProtectedRoute>} />
          <Route path="/coo/employees/add" element={<ProtectedRoute><COOCreateEmployee /></ProtectedRoute>} />
          <Route path="/coo/employees/update/:id" element={<ProtectedRoute><COOEditEmployee /></ProtectedRoute>} />
          <Route path="/coo/employee/:id/update" element={<ProtectedRoute><COOEditEmployee /></ProtectedRoute>} />
          {/* <Route path="/coo/hod/:id/report" element={<ProtectedRoute><COSEmployeeReport /></ProtectedRoute>} /> */}

          <Route path="/coo/key-result-areas" element={<ProtectedRoute><COOKRAs /></ProtectedRoute>} />
          <Route path="/coo/create-key-result-area" element={<ProtectedRoute><COOAddKRA /></ProtectedRoute>} />
          <Route path="/coo/key-result-areas/add" element={<ProtectedRoute><COOAddKRA /></ProtectedRoute>} />

          <Route path="/coo/kpis" element={<ProtectedRoute><COOGoals /></ProtectedRoute>} />
          <Route path="/coo/kpis/add" element={<ProtectedRoute><COOCreateGoal /></ProtectedRoute>} />
          <Route path="/coo/create-goal" element={<ProtectedRoute><COOCreateGoal /></ProtectedRoute>} />
          <Route path="/coo/kpi-reviews" element={<ProtectedRoute><COOGoalsReview /></ProtectedRoute>} />
          <Route path="/coo/my-goal-reviews" element={<ProtectedRoute><COOGoalsReview /></ProtectedRoute>} />
          <Route path="/coo/my-goals-reviews" element={<ProtectedRoute><COOGoalsReview /></ProtectedRoute>} />

          <Route path="/coo/pending-goals" element={<ProtectedRoute><COOPendingGoals /></ProtectedRoute>} />
          <Route path="/coo/employee-goals/:id" element={<ProtectedRoute><COOEmployeeGoals /></ProtectedRoute>} />
          <Route path="/coo/employee/:id/goals" element={<ProtectedRoute><COOEmployeeGoals /></ProtectedRoute>} />
          <Route path="/coo/employee-goals/:id/reviews" element={<ProtectedRoute><COOEmployeeGoalsReview /></ProtectedRoute>} />
          <Route path="/coo/employee-goals-review/:id" element={<ProtectedRoute><COOEmployeeGoalsReview /></ProtectedRoute>} />

          <Route path="/coo/improvement-plans" element={<ProtectedRoute><COOImprovementPlans /></ProtectedRoute>} />
          <Route path="/coo/improvement-plans/add" element={<ProtectedRoute><COOCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/coo/create-improvement-plan" element={<ProtectedRoute><COOCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/coo/edit-improvement-plan/:id" element={<ProtectedRoute><COOEditIP /></ProtectedRoute>} />
          <Route path="/coo/hods-improvement-plans" element={<ProtectedRoute><COOHODsImprovementPlans /></ProtectedRoute>} />
          <Route path="/coo/hod/:employeeId/report" element={<ProtectedRoute><HODsReport /></ProtectedRoute>} />

          <Route path="/hod/dashboard" element={<ProtectedRoute><HODDashboard /></ProtectedRoute>} />
          <Route path="/hod/kras/add" element={<ProtectedRoute><HODAddKRA /></ProtectedRoute>} />
          <Route path="/hod/improvement-plans/add" element={<ProtectedRoute><HODCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/hod/improvement-plans" element={<ProtectedRoute><HODImprovementPlan /></ProtectedRoute>} />
          <Route path="/hod/key-result-areas" element={<ProtectedRoute><HODKRAs /></ProtectedRoute>} />
          <Route path="/hod/kpis" element={<ProtectedRoute><HODGoals /></ProtectedRoute>} />
          <Route path="/hod/change-password" element={<ProtectedRoute><HODChangePassword /></ProtectedRoute>} />
          <Route path="/hod/two-factor-authentication" element={<ProtectedRoute><HODTwoFactorAuth /></ProtectedRoute>} />
          <Route path="/hod/kpis/add" element={<ProtectedRoute><HODCreateGoal /></ProtectedRoute>} />
          <Route path="/hod/create-key-result-area" element={<ProtectedRoute><HODAddKRA /></ProtectedRoute>} />
          <Route path="/hod/create-improvement-plan" element={<ProtectedRoute><HODCreateImprovementPlan /></ProtectedRoute>} />
          <Route path="/hod/edit-improvement-plan/:id" element={<ProtectedRoute><HODEditIP /></ProtectedRoute>} />
          <Route path="/hod/employee-goals/:id" element={<ProtectedRoute><HODEmployeeGoals /></ProtectedRoute>} />
          <Route path="/hod/employee/:id/goals" element={<ProtectedRoute><HODEmployeeGoals /></ProtectedRoute>} />
          <Route path="/hod/employee-goals/:id/reviews" element={<ProtectedRoute><EmployeeGoalsReviews /></ProtectedRoute>} />
          <Route path="/hod/pending-goals" element={<ProtectedRoute><PendingGoals /></ProtectedRoute>} />
          <Route path="/hod/my-goals-reviews" element={<ProtectedRoute><MyReviews /></ProtectedRoute>} />
          <Route path="/hod/employees" element={<ProtectedRoute><DepartmentEmployees /></ProtectedRoute>} />
          <Route path="/hod/employees/add" element={<ProtectedRoute><HODCreateEmployee /></ProtectedRoute>} />
          <Route path="/hod/employees/improvement-plans" element={<ProtectedRoute><EmployeeImprovementPlan /></ProtectedRoute>} />
          <Route path="/hod/employees/:id" element={<ProtectedRoute><HODUpdateEmployee /></ProtectedRoute>} />
          <Route path="/hod/employee/:employeeId/report" element={<ProtectedRoute><HODEmployeeReport /></ProtectedRoute>} />
          <Route path="/hod/employee-report/:employeeId" element={<ProtectedRoute><HODEmployeeReport /></ProtectedRoute>} />
          <Route path="/hod/profile" element={<ProtectedRoute><HODProfile /></ProtectedRoute>} />


          {/* Employee Routes */}
          <Route path="/employee/dashboard" element={<ProtectedRoute><EmployeeDashboard /></ProtectedRoute>} />
          <Route path="/employee/kras/add" element={<ProtectedRoute><AddKRA /></ProtectedRoute>} />
          <Route path="/employee/improvement-plans/add" element={<ProtectedRoute><CreateImprovementPlan/></ProtectedRoute>} />
          <Route path="/employee/kpi-reviwes" element={<ProtectedRoute><GoalReviews/></ProtectedRoute>} />
          <Route path="/employee/improvement-plans" element={<ProtectedRoute><ImprovementPlans/></ProtectedRoute>} />
          <Route path="/employee/kras" element={<ProtectedRoute><KRAs/></ProtectedRoute>} />
          <Route path="/employee/kpis" element={<ProtectedRoute><MyGoals/></ProtectedRoute>} />
          <Route path="/employee/edit-improvement-plan/:id" element={<ProtectedRoute><EmployeeEditIP/></ProtectedRoute>} />
          <Route path="/employee/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} /> 
          <Route path="/employee/two-factor-authentication" element={<ProtectedRoute><EmployeeTwoFactorAuth /></ProtectedRoute>} />
          <Route path="/employee/kpis/add" element={<ProtectedRoute><CreateGoal /></ProtectedRoute>} />

          <Route path="/hr/system-updates" element={<ProtectedRoute><SystemUpdates /></ProtectedRoute>} />
          

          {/* Fallback: unknown route → login (unauth) or role dashboard (auth) */}
          <Route path="*" element={<RoleRedirect />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
